import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  Response,
  TokenData,
  UserSignUpData,
  UserSignInData,
  UserData,
  ResetPasswordData,
  SetPasswordData,
  ResendEmailData,
  VerifyEmailData,
  UserGoogleSignUpData, OIDCLoginData
} from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  constructor(private readonly http: HttpClient) {}

  userSignInRequest(data: UserSignInData): Observable<Response<TokenData>> {
    return this.http.post<Response<TokenData>>(`${environment.baseUrl}/auth/sign-in/password`, data);
  }

  signInWithGoogleRequest(googleIdToken: string): Observable<Response<TokenData>> {
    return this.http.post<Response<TokenData>>(`${environment.baseUrl}/auth/sign-in/google`, { googleIdToken });
  }

  signUpWithGoogleRequest(signUpData: UserGoogleSignUpData): Observable<Response<TokenData>> {
    return this.http.post<Response<TokenData>>(`${environment.baseUrl}/users/sign-up/google`, signUpData);
  }

  linkGoogleAccountRequest(googleIdToken: string): Observable<Response<TokenData>> {
    return this.http.post<Response<TokenData>>(`${environment.baseUrl}/auth/account/link/google`, { googleIdToken });
  }

  userSignUpRequest(data: UserSignUpData): Observable<Response<UserData>> {
    return this.http.post<Response<UserData>>(`${environment.baseUrl}/users/sign-up`, {
      ...data,
      lastName: data.lastName || null
    });
  }

  resetPasswordRequest(data: ResetPasswordData): Observable<Response<any>> {
    return this.http.post<Response<any>>(`${environment.baseUrl}/auth/password/reset/request`, data);
  }

  setPasswordRequest(data: SetPasswordData): Observable<Response<any>> {
    return this.http.post<Response<any>>(`${environment.baseUrl}/auth/password/reset/submit`, data);
  }

  verifyEmailRequest(data: VerifyEmailData): Observable<Response<any>> {
    return this.http.post<Response<any>>(`${environment.baseUrl}/users/verify-email/submit`, data);
  }

  resendEmailRequest(data: ResendEmailData): Observable<Response<any>> {
    return this.http.post<Response<any>>(`${environment.baseUrl}/users/verify-email/request`, data);
  }

  refreshTokenRequest(refreshToken: string, companyId?: number | string): Observable<Response<TokenData>> {
    const payload: any = { refreshToken };

    if (companyId) {
      payload.companyId = companyId;
    }

    return this.http.post<Response<TokenData>>(`${environment.baseUrl}/auth/token/refresh`, payload);
  }

  companyAuthRequest(companyId: string): Observable<Response<TokenData>> {
    return this.http.post<Response<TokenData>>(`${environment.baseUrl}/auth/company`, { companyId: companyId });
  }

  companyOIDCAuthRequest(companyId: string, providerId: string): Observable<Response<OIDCLoginData>> {
    return this.http.post<Response<OIDCLoginData>>(`${environment.baseUrl}/auth/company/${companyId}/oidc/${providerId}/init`, {});
  }

  companyOIDCExchangeRequest(companyId: string, code: string): Observable<Response<TokenData>> {
    return this.http.post<Response<TokenData>>(`${environment.baseUrl}/auth/company/${companyId}/oidc/exchange`, { code: code });
  }
}
